import { FlexBox, Text } from '@dixa/lib-shared-habla';
import type { OpeningHours } from 'lib-shared-types-api';
import { useMemo } from 'react';

import { getRegularHours } from '../../utils/hours';

type Props = {
  isScheduleSelected: boolean;
  openingHours: readonly OpeningHours[] | undefined;
};

export function BusinessHours({
  isScheduleSelected,
  openingHours,
}: Props): JSX.Element {
  const regularBusinessHours = useMemo(
    () => getRegularHours(openingHours || []),
    [openingHours],
  );
  const businessHourExceptionCount = useMemo(
    () =>
      (openingHours || []).reduce(
        (acc, { opening_hour_type }) =>
          acc + (opening_hour_type !== 'regular' ? 1 : 0),
        0,
      ),
    [openingHours],
  );

  return (
    <FlexBox
      alignItems="center"
      background="neutral.100"
      borderRadius="100"
      padding="300"
      margin="200 0 0"
    >
      <Text.Paragraph variant="2">
        {regularBusinessHours.map(([name, hours]) => (
          <span key={name}>
            {name} <strong>{hours},</strong>{' '}
          </span>
        ))}
        {!isScheduleSelected
          ? 'No schedule selected'
          : `${businessHourExceptionCount} ${
              businessHourExceptionCount === 1 ? 'exception' : 'exceptions'
            }`}
      </Text.Paragraph>
    </FlexBox>
  );
}
